'use strict';

const errorCodes = [500, 501, 404, 400];

module.exports = {
  SERVER_ERROR_CODES: errorCodes,
};
